<div class="flex flex-col gap-4">
    <p-card header="Seasonal Staffing">
        <div [formGroup]="searchForm" class="search-form">
            <div class="">
                <label for="dateRange" class="font-medium text-center">Date Range:</label>
                <app-date-range-picker appendTo="body" [presets]="tripDatePresets" formControlName="dateRange">
                </app-date-range-picker>
            </div>
            
            <div class="items-center">
               <div class="flex items-center gap-2">
                   <span class="font-semibold">Search by end date</span>
                    <p-checkbox formControlName="useEndDate" [binary]="true"></p-checkbox>
               </div>
             
            </div>
            <button pButton type="button" label="Search" class="w-40" (click)="search()"></button>
        </div>
    </p-card>

    @if(hasSearched()) {
    <div class="grid grid-cols-1 gap-4 mt-4">
        @if(isLoading()) {
        <p-card>
            <div class="flex justify-center items-center p-8">
                <div class="text-center">
                    <i class="pi pi-spin pi-spinner text-4xl mb-2"></i>
                    <p>Loading seasonal staffing data...</p>
                </div>
            </div>
        </p-card>
        } @else {
        <!-- Trip Leader Staffing Table -->
        <p-card header="Trip Leader Staffing">
            <p-table #tripLeaderTable [value]="tripLeaderStaffing()" [columns]="tripLeaderColumns()"
                styleClass="p-datatable-gridlines" [paginator]="true" [rows]="10"
                [rowsPerPageOptions]="[10, 25, 50, 100]" sortMode="multiple"
                [globalFilterFields]="['tripId', 'tripdate', 'locName', 'tl']">

                <ng-template #caption>
                    <app-table-caption [table]="tripLeaderTable"></app-table-caption>
                </ng-template>

            <ng-template pTemplate="header">
                    <tr>
                        <app-table-headers [columns]="tripLeaderColumns()"></app-table-headers>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                    <tr>
                        <app-table-columns [columns]="tripLeaderColumns()" [data]="item"></app-table-columns>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="10" class="text-center p-4">
                            No trip leader staffing data found for the selected criteria.
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>

        <!-- Assistant Leader Table -->
        <p-card header="Assistant Leader Staffing">
            <p-table #assistantLeaderTable [value]="assistantLeaderDetails()" [columns]="assistantLeaderDetailsColumns()"
                styleClass="p-datatable-gridlines" [paginator]="true" [rows]="10"
                [rowsPerPageOptions]="[10, 25, 50, 100]" sortMode="multiple"
                [globalFilterFields]="['tripId', 'tripdate', 'locName', 'assistant']">

                <ng-template #caption>
                    <app-table-caption [table]="assistantLeaderTable"></app-table-caption>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <app-table-headers [columns]="assistantLeaderDetailsColumns()"></app-table-headers>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                    <tr>
                        <app-table-columns [columns]="assistantLeaderDetailsColumns()" [data]="item"></app-table-columns>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="10" class="text-center p-4">
                            No assistant leader staffing data found for the selected criteria.
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>

        <!-- Site Leader Table -->
        <p-card header="Site Leader Staffing">
            <p-table #siteLeaderTable [value]="siteLeaderDetails()" [columns]="siteLeaderDetailsColumns()"
                styleClass="p-datatable-gridlines" [paginator]="true" [rows]="10"
                [rowsPerPageOptions]="[10, 25, 50, 100]" sortMode="multiple" [globalFilterFields]="['tripId', 'tripdate', 'locName', 'assistant', 'sl']">

                <ng-template #caption>
                    <app-table-caption [table]="siteLeaderTable"></app-table-caption>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <app-table-headers [columns]="siteLeaderDetailsColumns()"></app-table-headers>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                    <tr>
                        <app-table-columns [columns]="siteLeaderDetailsColumns()" [data]="item"></app-table-columns>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="10" class="text-center p-4">
                            No site leader staffing data found for the selected criteria.
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
        }
    </div>
    }
</div>